import { useEffect } from "react";
import Lenis from "lenis";

/** Mounts a global Lenis instance for buttery smooth scrolling. */
export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    let raf;
    const tick = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    // Make in-page anchor links use Lenis (so /#pricing scrolls smoothly)
    const onClick = (e) => {
      const a = e.target.closest("a[href^='#'], a[href^='/#']");
      if (!a) return;
      const href = a.getAttribute("href");
      const hash = href.includes("#") ? href.slice(href.indexOf("#") + 1) : "";
      const el = hash && document.getElementById(hash);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return null;
}
